import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { humanize } from 'utils'
import StyleSheet from 'styles/StyleSheet'
import Typography from '@material-ui/core/Typography'
import { DateTimeDisplay } from 'components/DateTimeDisplay'
import {FormattedMessage} from 'react-intl'

export class KeyInformation extends Component {

  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () => {
    const { dealSheet } = this.props
    const isProduct = dealSheet.typeOfIssuance === 'product'
    return (
      <div className={this.props.className}>
        <Typography variant='h5'><FormattedMessage id="deal.key_info.title" /></Typography>
        <dl className={styles.keyPoints}>
          {dealSheet.tickerLongForm &&
            <Fragment>
              <dt><FormattedMessage id="deal.key_info.name_label" /></dt>
              <dd>{dealSheet.tickerLongForm}</dd>
            </Fragment>
          }
          {dealSheet.typeOfIssuance && !isProduct &&
            <Fragment>
              <dt>Deal Type</dt>
              <dd>{humanize(dealSheet.typeOfIssuance)}</dd>
            </Fragment>
          }
          {dealSheet.ticker &&
            <Fragment>
              <dt><FormattedMessage id="deal.key_info.ticker_label" /></dt>
              <dd>{dealSheet.ticker}</dd>
            </Fragment>
          }
          {dealSheet.tokenSaleWebsite &&
            <Fragment>
              <dt key={1}><FormattedMessage id="deal.key_info.website_label" /></dt>
              <dd key={2}><a className={styles.link} href={dealSheet.tokenSaleWebsite}>{dealSheet.tokenSaleWebsite}</a></dd>
            </Fragment>
          }

          {!isProduct &&
            <Fragment><dt>Start Date</dt>
              <dd><DateTimeDisplay value={dealSheet.startDate} singleLine /></dd>

              <dt>End Date</dt>
              <dd><DateTimeDisplay value={dealSheet.endDate} singleLine /></dd>
            </Fragment>
          }
        </dl>
        {dealSheet.socialMediaLinks && dealSheet.socialMediaLinks.length > 0 &&
          <ul className={styles.socialMediaLinks}>
            {dealSheet.socialMediaLinks.filter(link => link.linkUrl).map(link =>
              <li key={link.id}><a href={link.linkUrl}><img src={link.iconUrl} alt={link.name}/></a></li>
            )}
          </ul>
        }
      </div>
    )
  }
}

const styles = StyleSheet({
  keyPoints: {
    paddingTop: 12,
    paddingBottom: 12,
    '& dt': {
      fontWeight: 'bold',
      color: '#586c7b',
      width: '225px',
      float: 'left',
      clear: 'both',
      paddingBottom: 3,
      '@media(max-width: 600px)': {
        width: '150px',
        fontSize: '12px'
      }
    },
    '& dd': {
      fontWeight: 'bold',
      display: 'inline-block',
      float: 'left',
      margin: 0,
      paddingBottom: 12,
      '@media(max-width: 600px)': {
        fontSize: '12px'
      }
    },
    '&:after': {
      content: "''",
      clear: 'both',
      display: 'block',
    }
  },
  link: {
    color: '#6AAEAA'
  },
  socialMediaLinks: {
    listStyleType: 'none',
    padding: 0,
    '& li': {
      display: 'inline-block',
      paddingRight: 10,
    },
    '& img': {
      maxWidth: 37
    }
  }
})

export default KeyInformation